import { FC, useMemo } from 'react';
import ResizedImageEnhanced from '../../../../components/ResizedImageEnhanced';
import {
  LongreadBlockWrapper,
  ImageBlock,
} from '../../styles/LongreadBlockRenderer.styles';
import { useGetCardCached } from '../../hooks';
import { getCardIdFromBlock } from '../../utils/blockUtils';

interface CardBlockProps {
  block: any;
  backgroundColor?: string;
}

export const CardBlock: FC<CardBlockProps> = ({ block }) => {
  const cardId = useMemo(() => getCardIdFromBlock(block), [block]);
  const { card, isLoading } = useGetCardCached(cardId || '', !cardId);

  if (!cardId) return null;

  if (isLoading) {
    return (
      <LongreadBlockWrapper>
        <ImageBlock style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#F2F2F2' }} />
      </LongreadBlockWrapper>
    );
  }

  if (!card?.images?.length) return null;

  return (
    <LongreadBlockWrapper>
      <ImageBlock data-card-block>
        <a
          href={`${window.location.origin}/card/${cardId}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: 'block', width: '100%', height: '100%', cursor: 'pointer' }}
        >
          <ResizedImageEnhanced files={card.images} />
        </a>
      </ImageBlock>
    </LongreadBlockWrapper>
  );
};
import { FC, useMemo } from 'react';
import ResizedImageEnhanced from '../../../../components/ResizedImageEnhanced';
import {
  LongreadBlockWrapper,
  ImageBlock,
} from '../../styles/LongreadBlockRenderer.styles';
import { useGetCardCached } from '../../hooks';
import { getCardIdFromBlock } from '../../utils/blockUtils';

interface CardBlockProps {
  block: any;
  backgroundColor?: string;
}

export const CardBlock: FC<CardBlockProps> = ({ block }) => {
  const cardId = useMemo(() => getCardIdFromBlock(block), [block]);
  const { card, isLoading } = useGetCardCached(cardId || '', !cardId);

  if (!cardId) return null;

  if (isLoading) {
    return (
      <LongreadBlockWrapper>
        <ImageBlock style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#F2F2F2' }} />
      </LongreadBlockWrapper>
    );
  }

  if (!card?.images?.length) return null;

  return (
    <LongreadBlockWrapper>
      <ImageBlock data-card-block>
        <a
          href={`${window.location.origin}/card/${cardId}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: 'block', width: '100%', height: '100%', cursor: 'pointer' }}
        >
          <ResizedImageEnhanced files={card.images} />
        </a>
      </ImageBlock>
    </LongreadBlockWrapper>
  );
};
